<template>
  <div class="sidebar" v-if="!item.hidden&&item.num>0">
    <el-popover popper-class="sidebar_popover" placement="right" title="" :width="locale=='zh-CN'?'420':'540'" trigger="hover">
      <div class="sidebar_content">
        <div v-for="(itm,ind) in item.children" :key="ind">
          <blockquote v-if="itm.children.length">
            <p class="sidebar_title">{{itm.title}}</p>
            <div class="sidebar_list">
              <div class="sidebar_link" v-for="(tag,key) in itm.children" :key="key" v-show="tag">
                <div v-if="tag">
                  <router-link class="sidebar_link_span" tag="span" :to="tag.path">
                    <span>{{tag.name}}</span>
                  </router-link>
                </div>
              </div>
            </div>
          </blockquote>
        </div>
      </div>

      <div class="sidebar_btn" slot="reference">
        <i :class="item.icon"></i>
        <span>{{item.name}}</span>
      </div>
    </el-popover>
  </div>
</template>

<script>
  export default {
    name: 'SidebarItem',
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    data() {
      return {}
    },
    computed:{
      locale(){
        return this.$i18n.locale
      }
    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>
  .sidebar {
    &_btn {
      width: 66px;
      height: 66px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #fff;
      text-align: center;
      cursor: pointer;

      i[class^=el-icon] {
        font-size: 26px;
        margin-bottom: 2px;
      }

      &:hover {
        background-color: var(--theme-color);
      }
    }

    &_title {
      font-size: 14px;
      color: var(--theme-color2);
      margin: 10px 0;
    }

    &_link {
      flex-shrink: 0;
      width: 33.33%;
      display: inline-block;
      font-size: 13px;
      color: #333;
      padding-right: 10px;
      margin: 0 0 10px;
      box-sizing: border-box;

      &_span {
        cursor: pointer;

        &:hover {
          color: var(--theme-color);
          border-bottom: 1px solid var(--theme-color);
        }
      }

      .router-link-exact-active{
        color: var(--theme-color);
        border-bottom: 1px solid var(--theme-color);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Sidebar/SidebarItem.vue